import SearchOutlined from '@material-ui/icons/SearchOutlined'
import { InputAdornment } from 'opensolar-ui'
import { useEffect, useState } from 'react'
import { CatalogSearchField } from './utilityTariffCatalogStyles'

type UtilityTariffCatalogSearchFieldProps = {
  filterValues?: Record<string, unknown>
  setFilters?: (filters: Record<string, unknown>) => void
  placeholder?: string
}

export const UtilityTariffCatalogSearchField = ({
  filterValues,
  setFilters,
  placeholder = 'Search',
}: UtilityTariffCatalogSearchFieldProps) => {
  const [value, setValue] = useState(() => String(filterValues?.q ?? ''))

  useEffect(() => {
    setValue(String(filterValues?.q ?? ''))
  }, [filterValues?.q])

  if (!setFilters) {
    return null
  }

  return (
    <CatalogSearchField
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(event) => {
        const q = event.target.value
        setValue(q)
        setFilters({ ...(filterValues || {}), q })
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  )
}
